import * as React from 'react';
import { useState, useEffect } from 'react';
import {
  Box,
  Stack,
  Container,
  Typography,
  Snackbar,
  Alert,
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Checkbox,
  IconButton,
  Tabs,
  Tab,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Pagination,
  CircularProgress,
  PaginationItem,
  DialogContentText,
  Rating,
  Grid,
  Divider,
  Collapse,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { Link as RouterLink } from 'react-router-dom';

//components
import Page from '../../components/Page';
import Iconify from 'src/components/Iconify';

//icons
import Empty_Truck from '../../../src/asset/open-door.png';
import { Add, Remove } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { api, mainurl } from 'src/Api';
import moment from 'moment';
import { NumericFormat } from 'react-number-format';
import Searchbar from 'src/layouts/dashboard/Searchbar';
import GooglePlaces from 'src/components/GooglePlaces';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@emotion/react';
import LocationPickerMap from 'src/components/LocationPickerMap';

export default function MyShipmentList() {
  const theme = useTheme();
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem('user'));

  const [origin, setOrigin] = useState('');
  const [dhO, setDhO] = useState('');
  const [destination, setDestination] = useState('');
  const [dhD, setDhD] = useState('');
  const [equipmentType, setEquipmentType] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [loadType, setLoadType] = useState('');
  const [length, setLength] = useState('');
  const [weight, setWeight] = useState('');
  const [ageInHours, setAgeInHours] = useState('');
  const [privateLoadButton, setPrivateLoadButton] = useState(false);
  const [reSearch, setReSearch] = useState('');
  const [company, setCompany] = useState('');
  const [length_unit, setLength_unit] = useState('ft');
  const [weight_unit, setWeight_unit] = useState('kg');

  const [mapOpen, setMapOpen] = useState(false);
  const [locationType, setLocationType] = useState(''); // 'origin' or 'destination'
  const [openRequirmentModal, setOpenRequirmentModal] = useState(false);

  const [shipmentList, setShipmentList] = useState([]);

  const [selectedTab, setSelectedTab] = useState(0); // State to handle the active tab
  const [loading, setloading] = useState(false);
  const [loadingcheckout, setLoadingCheckout] = useState(false);
  const [optionsLoader, setOptionsLoader] = useState(false);
  const [extendLoading, setExtendLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const [openSearchBack, setOpenSearchBack] = useState(false);

  const [expandedRow, setExpandedRow] = useState(null);

  const [optionNumber, setOptionNumber] = useState('');

  const [openAlertModal, setOpenAlertModal] = useState(false);
  const [openRatingModal, setOpenRatingModal] = useState(false);

  const [pagesCount, setpagesCount] = useState(1);
  const [page, setPage] = useState(1);

  const [selected, setSelected] = useState([]); // To hold selected truck objects
  const [anchorEl, setAnchorEl] = useState(null); // For 3-dot menu control
  const [selectedTruck, setSelectedTruck] = useState(null); // Track which truck is selected for menu
  console.log('🚀 ~ MyShipmentList ~ selectedTruck:', selectedTruck);

  const [open, setOpen] = useState(false);
  const [days, setDays] = useState(1);

  const [rating, setRating] = useState(0);
  const [review, setReview] = useState('');

  const [selectLoad, setSelectLoad] = useState('');
  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const [searchLoading, setsearchLoading] = useState(false);
  const [search, setsearch] = useState('');

  const [equipmentList, setEquipmentList] = useState([]);
  const [compnayList, setCompnayList] = useState([]);

  const [clearFilterTrigger, setClearFilterTrigger] = useState(false);
  const [isFilled, setIsFilled] = useState(false);
  const [isSearchFilled, setIsSearchFilled] = useState(false);
  const [openCompany, setOpenCompany] = useState(false);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue); // Switch the tab based on user selection
  };

  useEffect(() => {
    getEquipments();
    getShipmentList(1);
  }, []);

  useEffect(() => {
    getShipmentList(1);
  }, [company, origin, destination]);

  useEffect(() => {
    getShipmentList(1);
  }, [privateLoadButton]);

  useEffect(() => {
    if (clearFilterTrigger) {
      getShipmentList(1);
      setClearFilterTrigger(false); // Reset kar dete hain taake ye baar baar trigger na ho
    }
  }, [clearFilterTrigger]);

  useEffect(() => {
    if (reSearch) {
      getShipmentList(1);
    }
  }, [reSearch]);

  function getEquipments() {
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(api.get_equipments, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setEquipmentList(result.data);
      })
      .catch((error) => console.log('error', error));
  }

  function getShipmentList(page) {
    setShipmentList([]);
    setloading(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    const queryParams = new URLSearchParams();
    page && queryParams.append('page', page);
    origin?.address && queryParams.append('location_origin', origin?.address); // Required
    origin?.country && queryParams.append('country_origin', origin?.country); // Optional
    origin?.city && queryParams.append('city_origin', origin?.city); // Optional
    origin?.state && queryParams.append('state_origin', origin?.state); // Optional
    origin?.lat && queryParams.append('lat_origin', origin?.lat); // Required
    origin?.lon && queryParams.append('lon_origin', origin?.lon); // Required
    origin?.zone && queryParams.append('zone_origin', origin?.zone); // Required
    // origin.address && queryParams.append('location_origin', origin.address);
    dhO && queryParams.append('dho', dhO);
    // destination.address && queryParams.append('location_destination', destination.address);
    destination?.address && queryParams.append('location_destination', destination?.address); // Required
    destination?.country && queryParams.append('country_destination', destination?.country); // Optional
    destination?.city && queryParams.append('city_destination', destination?.city); // Optional
    destination?.state && queryParams.append('state_destination', destination?.state); // Optional
    destination?.lat && queryParams.append('lat_destination', destination?.lat); // Required
    destination?.lon && queryParams.append('lon_destination', destination?.lon); // Required
    destination?.zone && queryParams.append('zone_destination', destination?.zone); // Required
    dhD && queryParams.append('dhd', dhD);
    length_unit && length && queryParams.append('length_unit', length_unit);
    weight_unit && weight && queryParams.append('weight_unit', weight_unit);
    equipmentType && queryParams.append('equipment_id', equipmentType);
    startDate && queryParams.append('pickup_earliest', moment(startDate).format('YYYY-MM-DD'));
    endDate && queryParams.append('pickup_lattest', moment(endDate).format('YYYY-MM-DD'));
    loadType && queryParams.append('equipment_type', loadType);
    length && queryParams.append('length_ft', length);
    weight && queryParams.append('weight_lbs', weight);
    ageInHours && queryParams.append('age', ageInHours);
    company && queryParams.append('company', company);
    privateLoadButton && queryParams.append('audience_type', privateLoadButton ? 'Private' : 'All');

    fetch(`${api.get_shipment}?${queryParams.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          setShipmentList(result.data);
          result?.count ? setpagesCount(Math.ceil(result?.count / 10)) : setpagesCount(1);
          setloading(false);
          setsearchLoading(false);
        } else {
          setShipmentList([]);
          setpagesCount(0);
          setloading(false);
          setsearchLoading(false);
        }
      })
      .catch((error) => {
        console.log('error', error);
        setloading(false);
        setsearchLoading(false);
      });
  }

  function getCompanyList() {
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(api.get_companies, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setCompnayList(result.data);
      })
      .catch((error) => console.log('error', error));
  }

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleStartDateChange = (value) => {
    setStartDate(value ? value.toISOString() : null);
  };

  const handleEndDateChange = (value) => {
    setEndDate(value ? value.toISOString() : null);
  };

  const handleOpenCompany = () => setOpenCompany(true);
  const handleCloseCompany = () => {
    setOpenCompany(false);
  };

  const handleOpenRequirmentModal = () => setOpenRequirmentModal(true);
  const handleCloseRequirmentModal = () => {
    setOpenRequirmentModal(false);
    setLoadType('');
    setLength('');
    setWeight('');
  };

  const handleOpenSearchBack = () => setOpenSearchBack(true);
  const handleCloseSearchBack = () => {
    setOpenSearchBack(false);
    setAgeInHours('');
  };

  const handleOpenDetailsModal = (val) => {
    setOpenDetailsModal(true);
  };
  const handleCloseDetailsModal = () => {
    setOpenDetailsModal(false);
  };

  const handleCompanyClick = (zone) => {
    setCompany(zone); // Set selected zone in input field
    handleCloseCompany(); // Close modal after selection
    setReSearch('');
  };

  const handleClearAllSearchBack = () => {
    setAgeInHours('');
    setReSearch('2');
    setIsSearchFilled(false);
    setOpenSearchBack(false);
    getShipmentList(1);
  };

  const handleDoneSearchBack = () => {
    if (ageInHours) {
      setIsSearchFilled(true);
      setOpenSearchBack(false);
      setReSearch('');
      getShipmentList(1);
    } else {
      setIsSearchFilled(false);
      setOpenSearchBack(false);
      setReSearch('');
    }
  };

  // Handle clearing selected comapny
  const clearSelectionCompany = () => {
    setCompany('');
    handleCloseCompany();
    setReSearch('3');
    // getSearchLoadData(1)
  };

  const handleClearAll = () => {
    setLoadType('');
    setLength('');
    setWeight('');
    setReSearch('1');
    setIsFilled(false);
    setOpenRequirmentModal(false);
    getShipmentList(1);
  };

  // Handle Done Requirment
  const handleDone = () => {
    if (loadType || length || weight) {
      setIsFilled(true);
      setOpenRequirmentModal(false);
      setReSearch('');
      getShipmentList(1);
    } else {
      setIsFilled(false);
      setOpenRequirmentModal(false);
      setReSearch('');
    }
  };

  //handle change requirment
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'length') {
      if (e.target.value.length <= 7) {
        setLength(value);
      }
    }
    if (name === 'weight') {
      if (e.target.value.length <= 7) {
        setWeight(value);
      }
    }
  };

  const handlePageChange = (event, value) => {
    shipmentList.length = 0;
    setPage(value);
    getShipmentList(value);
  };

  const handleClearFilter = () => {
    setPage(1);
    setOrigin(''); // Reset origin here
    setDhO('');
    setDhD('');
    setDestination('');
    setEquipmentType('');
    setStartDate(null);
    setEndDate(null);
    setLoadType('');
    setLength('');
    setWeight('');
    setAgeInHours('');
    setPrivateLoadButton(false);
    setCompany('');
    setClearFilterTrigger(true);
    setIsFilled(false);
    setIsSearchFilled(false);
  };

  const handleRowClick = (rowIndex) => {
    setExpandedRow((prevIndex) => (prevIndex === rowIndex ? null : rowIndex));
  };

  const handleLocationIconClick = (type) => {
    setLocationType(type);
    setMapOpen(true);
  };

  const handleSelectLocation = (type, locationData) => {
    if (type === 'origin') {
      setOrigin(locationData);
    } else if (type === 'destination') {
      setDestination(locationData);
    }
    setMapOpen(false);
  };

  // FILTERS FUNCTION END

  useEffect(() => {
    getShipmentList(page);
  }, [page]);

  // const isAllSelected = selected.length === shipmentList.length;
  const isAllSelected =
    selected.length ===
    shipmentList.filter((truck) => truck.status.toLowerCase() !== 'expired').length;

  // Toggle individual row selection
  const handleSelectRow = (truck) => {
    const selectedIndex = selected.findIndex((item) => item === truck);

    if (selectedIndex > -1) {
      setSelected(selected.filter((item) => item !== truck)); // Deselect if already selected
    } else {
      setSelected([...selected, truck]); // Add truck to selected array
    }
  };

  // Toggle select all rows
  const handleSelectAll = () => {
    const nonExpiredShipments = shipmentList.filter(
      (truck) => truck.status.toLowerCase() !== 'expired'
    );
    if (isAllSelected) {
      setSelected([]); // Deselect all
    } else {
      setSelected(nonExpiredShipments); // Select only non-expired trucks
    }
  };

  const handleMenuClick = (event, truck) => {
    setAnchorEl(event.currentTarget);
    setSelectedTruck(truck); // Set the truck for which menu is open
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedTruck(null); // Reset the selected truck
  };

  const handleOptionSelect = (option) => {
    setOptionNumber(option);
    if (selected.length == 0) {
      ChangeShipmentStatus(option);
    } else {
      ChangeBulkShipmentStatus(option);
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
    setAnchorEl(null);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleIncrement = () => {
    setDays((prevDays) => prevDays + 1);
  };

  const handleDecrement = () => {
    setDays((prevDays) => (prevDays > 1 ? prevDays - 1 : 1)); // Ensure at least 1 day
  };

  // extend_pickup_date_shipment
  function ExtendDaysFuntion() {
    setExtendLoading(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdatas = new FormData();
    selected && formdatas.append('id', selectedTruck?.id);
    formdatas.append('days', days);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdatas,
      redirect: 'follow'
    };

    fetch(api.extend_pickup_date_shipment, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          setExtendLoading(false);
          handleClose();
          setDays(1);
          getShipmentList(page);
        } else {
          setExtendLoading(false);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        }
      })
      .catch((error) => {
        setExtendLoading(false);
        setSnackbarMessage('An error occurred.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      });
  }

  // change_shipment_status
  function ChangeShipmentStatus(status) {
    setOptionsLoader(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdatas = new FormData();
    selected && formdatas.append('id', selectedTruck?.id);
    formdatas.append('status', status);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdatas,
      redirect: 'follow'
    };

    fetch(api.change_shipment_status, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          setOptionsLoader(false);
          handleMenuClose();
          handleCloseAlert();
          getShipmentList(page);
          setOptionNumber('');
        } else {
          setOptionsLoader(false);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        }
      })
      .catch((error) => {
        setOptionsLoader(false);
        setSnackbarMessage('An error occurred.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      });
  }

  // add_rating_review
  function handleAddRatingReview() {
    setOptionsLoader(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdatas = new FormData();
    selected && formdatas.append('booking_id', selectedTruck?.id);
    rating && formdatas.append('rating', rating);
    review && formdatas.append('review', review);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdatas,
      redirect: 'follow'
    };

    fetch(api.mark_as_complete, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          handleMenuClose();
          handleCloseRating();
          getShipmentList(page);
          setOptionsLoader(false);
          // handleCheckout()
        } else {
          setOptionsLoader(false);
          setSnackbarMessage(result.error);
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        }
      })
      .catch((error) => {
        setOptionsLoader(false);
        setSnackbarMessage('An error occurred.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      });
  }

  // Function to handle the checkout process
  const handleCheckout = async (price_id) => {
    setLoadingCheckout(true);
    try {
      const response = await fetch(`${mainurl}v1/payment/create-checkout-session-single-pay`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          user_id: userData?.id,
          shipment_id: selectedTruck?.id,
          amount: Number(selectedTruck?.booking_rate * 100),
          currency: 'USD',
          success_url: '/dashboard/my_shipments',
          cancel_url: '/dashboard/my_shipments'
        })
      });

      const data = await response.json();
      console.log('🚀 ~ handleCheckout ~ data:', data);
      setLoadingCheckout(false);
      window.location.href = data?.checkout_url;
    } catch (error) {
      setLoadingCheckout(false);
      console.error('Error creating checkout session:', error);
      // setMessage('An error occurred while processing your request.');
    }
  };

  // change_bulk_shipment_status
  function ChangeBulkShipmentStatus(status) {
    setOptionsLoader(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdatas = new FormData();
    if (selected && selected.length > 0) {
      const selectedIds = selected.map((item) => item.id);
      formdatas.append('ids', selectedIds);
    }
    formdatas.append('status', status);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdatas,
      redirect: 'follow'
    };

    fetch(api.change_bulk_shipment_status, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          setOptionsLoader(false);
          setSelected([]);
          handleMenuClose();
          getShipmentList(page);
          setOptionNumber('');
        } else {
          setOptionsLoader(false);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        }
      })
      .catch((error) => {
        setOptionsLoader(false);
        setSnackbarMessage('An error occurred.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      });
  }

  const handleOpenAlert = () => {
    setOpenAlertModal(true);
  };

  const handleCloseAlert = () => {
    setOpenAlertModal(false);
  };

  const handleOpenRating = () => {
    setOpenRatingModal(true);
  };

  const handleCloseRating = () => {
    setOpenRatingModal(false);
    setRating(0);
    setReview('');
  };

  const handleRatingChange = (event, newValue) => {
    setRating(newValue);
  };

  const handleReviewChange = (event) => {
    setReview(event.target.value);
  };

  return (
    <Page title={`My Shipments | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={0}>
          <Typography variant="h4" sx={{ color: '#010f58' }}>
            My Shipments
          </Typography>

          {userData?.role?.id !== 6 && (
            <Button
              variant="contained"
              component={RouterLink}
              to="/dashboard/my_shipments/form"
              startIcon={<Iconify icon="streamline:shipment-add" style={{ fontSize: 15 }} />}
              sx={{ alignSelf: 'end', fontSize: 11 }}
            >
              Add New Shipment
            </Button>
          )}
        </Stack>

        <Box sx={{ flexGrow: 1, marginTop: 2 }}>
          <Grid container spacing={1} alignItems="flex-start" justifyContent="space-between" mb={2}>
            {/* Origin Field */}
            <Grid item xs={12} sm={4.3} md={4.3}>
              <GooglePlaces
                width={'100%'}
                onResult={(val) => {
                  setOrigin(val);
                }}
                placeholder={'Origin'}
                // regions={true}
                address={origin?.address} // Ensure origin updates here
                stylePinIcon={{ fontSize: 12 }}
                styleCountryText={{ fontSize: 10 }}
                styleCityText={{ fontSize: 9 }}
                boxCountryCity={{ width: 20, paddingTop: 0 }}
              />
              <div
                style={{
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  marginTop: 5
                }}
                onClick={() => handleLocationIconClick('origin')}
              >
                <Iconify icon="mdi:location" style={{ color: '#010f58', fontSize: 20 }} />
                <p style={{ fontSize: 13, color: '#666', marginLeft: 5 }}>Set Location on map</p>
              </div>
            </Grid>

            {/* DH-O Field */}
            <Grid item xs={12} sm={1.3} md={1.3}>
              <TextField
                label="DH-O"
                type="number"
                value={dhO}
                inputProps={{
                  maxLength: 4
                }}
                onChange={(e) => {
                  if (e.target.value.length <= 4) {
                    setDhO(e.target.value);
                  }
                }}
                fullWidth
                className="custom-textfield"
                onKeyDown={(e) => {
                  if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                    e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                  }
                }}
              />
            </Grid>

            <Grid item mt={1.7}>
              <Iconify icon={'fa6-solid:right-left'} sx={{ fontSize: 12 }} />
            </Grid>

            {/* Destination Field */}
            <Grid item xs={12} sm={4.5} md={4.3}>
              <GooglePlaces
                width={'100%'}
                onResult={(val) => setDestination(val)}
                placeholder={'Destination'}
                // regions={true}
                address={destination?.address}
                stylePinIcon={{ fontSize: 12 }}
                styleCountryText={{ fontSize: 10 }}
                styleCityText={{ fontSize: 9 }}
                boxCountryCity={{ width: 20, paddingTop: 0 }}
              />
              <div
                style={{
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  marginTop: 5
                }}
                onClick={() => handleLocationIconClick('destination')}
              >
                <Iconify icon="mdi:location" style={{ color: '#010f58', fontSize: 20 }} />
                <p style={{ fontSize: 13, color: '#666', marginLeft: 5 }}>Set Location on map</p>
              </div>
            </Grid>

            {/* DH-D Field */}
            <Grid item xs={12} sm={1.3} md={1.3}>
              <TextField
                label="DH-D"
                type="number"
                value={dhD}
                onChange={(e) => {
                  if (e.target.value.length <= 4) {
                    setDhD(e.target.value);
                  }
                }}
                fullWidth
                className="custom-textfield"
                onKeyDown={(e) => {
                  if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                    e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                  }
                }}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} xs={13}>
            <Grid item spacing={2} xs={6}>
              <Grid item mb={2} xs={12}>
                <TextField
                  label="Origin/City"
                  type="text"
                  value={origin?.city || ''}
                  onChange={(e) =>
                    setOrigin((prev) => ({
                      ...prev,
                      city: e.target.value // ✅ yahan update hoga
                    }))
                  }
                  fullWidth
                  className="custom-textfield"
                />
              </Grid>

              <Grid item container spacing={2} xs={12} md={12}>
                <Grid item mb={2} xs={6}>
                  <TextField
                    label="Origin/State"
                    type="text"
                    value={origin?.state || ''}
                    onChange={(e) =>
                      setOrigin((prev) => ({
                        ...prev,
                        state: e.target.value // ✅ yahan update hoga
                      }))
                    }
                    fullWidth
                    className="custom-textfield"
                  />
                </Grid>
                <Grid item mb={2} xs={6}>
                  <TextField
                    label="Origin/Zip Code"
                    type="text"
                    value={origin?.zip_code || ''}
                    onChange={(e) => {
                      setOrigin((prev) => ({
                        ...prev,
                        zip_code: e.target.value // ✅ yahan update hoga
                      }));
                    }}
                    fullWidth
                    className="custom-textfield"
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item spacing={2} xs={6}>
              <Grid item mb={2} xs={12}>
                <TextField
                  label="Destination/City"
                  type="text"
                  value={destination?.city || ''}
                  onChange={(e) =>
                    setDestination((prev) => ({
                      ...prev,
                      city: e.target.value // ✅ yahan update hoga
                    }))
                  }
                  fullWidth
                  className="custom-textfield"
                />
              </Grid>

              <Grid item container spacing={2} xs={12} md={12}>
                <Grid item mb={2} xs={6}>
                  <TextField
                    label="Destination/State"
                    type="text"
                    value={destination?.state || ''}
                    onChange={(e) =>
                      setDestination((prev) => ({
                        ...prev,
                        state: e.target.value // ✅ yahan update hoga
                      }))
                    }
                    fullWidth
                    className="custom-textfield"
                  />
                </Grid>
                <Grid item mb={2} xs={6} md={6}>
                  <TextField
                    label="Destination/Zip Code"
                    type="text"
                    value={destination?.zip_code || ''}
                    onChange={(e) =>
                      setDestination((prev) => ({
                        ...prev,
                        zip_code: e.target.value // ✅ yahan update hoga
                      }))
                    }
                    fullWidth
                    className="custom-textfield"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid container spacing={1} alignItems="center" justifyContent="space-between" mb={2}>
            {/* Equipment Type Field */}
            <Grid item xs={12} sm={5.8} md={4.5}>
              <TextField
                select
                label="Equipment Type"
                value={equipmentType}
                onChange={(e) => setEquipmentType(e.target.value)}
                fullWidth
                // error={Boolean(errors.equipmentType)}
                // helperText={errors.equipmentType}
                InputLabelProps={{
                  shrink: true, // Force the label to shrink when a value is selected
                  style: {
                    fontSize: '11px',
                    lineHeight: '1.2',
                    transform: 'translate(14px, -6px) scale(1)' // Adjust position of label
                  }
                }}
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      style: {
                        paddingTop: 0 // Ensure the dropdown aligns properly
                      }
                    }
                  }
                }}
                InputProps={{
                  style: {
                    fontSize: 14,
                    height: '50px', // Set the height of the input field
                    padding: '0px 0px' // Add padding to input field
                  }
                }}
              >
                {equipmentList.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%'
                      }}
                    >
                      <span
                        style={{
                          flex: 1,
                          textAlign: 'start',
                          display: 'flex',
                          fontWeight: 'normal',
                          marginRight: 10,
                          fontSize: 14
                        }}
                      >
                        {option.name}
                      </span>
                      <span
                        style={{
                          flex: 1,
                          width: '100%',
                          textAlign: 'right',
                          fontWeight: 'bold',
                          fontSize: 14,
                          color: '#000'
                        }}
                      >
                        {option.code}
                      </span>
                    </div>
                  </MenuItem>
                ))}
              </TextField>
              {/* <TextField
                          select
                          label="Equipment Type"
                          value={equipmentType}
                          onChange={(e) => setEquipmentType(e.target.value)}
                          fullWidth
                          className="custom-dropdown"
                          InputLabelProps={{
                            shrink: true, // Force the label to shrink when a value is selected
                            style: {
                              fontSize: 9,
                              lineHeight: '1.2',
                              transform: 'translate(14px, -6px) scale(1)' // Adjust position of label
                            }
                          }}
                          SelectProps={{
                            MenuProps: {
                              PaperProps: {
                                style: {
                                  paddingTop: 0 // Ensure the dropdown aligns properly
                                }
                              }
                            }
                          }}
                          InputProps={{
                            style: {
                              fontSize: 12,
                              height: '40px', // Set the height of the input field
                              padding: '0px 0px' // Add padding to input field
                            }
                          }}
                        >
                          {equipmentList.map((option) => (
                            <MenuItem key={option.id} value={option.id}>
                              <p style={{ fontSize: 12, textAlign: 'start', display: 'flex' }}>
                                {option.name} -{' '}
                                <p
                                  style={{
                                    fontSize: 13,
                                    fontWeight: 'bold',
                                    color: '#010f58',
                                    marginLeft: 4,
                                    flex: 1
                                  }}
                                >
                                  {option.code}
                                </p>
                              </p>
                            </MenuItem>
                          ))}
                        </TextField> */}
            </Grid>

            {/* Date Range Field */}
            <Grid item xs={12} sm={4.5} md={5.1} sx={{ marginTop: -1 }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={['DatePicker']}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexDirection: 'row'
                  }}
                >
                  <Grid item>
                    <DatePicker
                      className="custom-textfield"
                      label="Start Date"
                      value={startDate ? dayjs(startDate) : null}
                      onChange={(newValue) => handleStartDateChange(newValue)}
                      // minDate={dayjs()}
                    />
                  </Grid>
                  <Grid item>
                    <DatePicker
                      className="custom-textfield"
                      label="End Date"
                      value={endDate ? dayjs(endDate) : null}
                      onChange={(newValue) => handleEndDateChange(newValue)}
                    />
                  </Grid>
                </DemoContainer>
              </LocalizationProvider>
            </Grid>

            {/* Search Button */}
            <Grid item xs={12} sm={4.5} md={1}>
              <Button
                variant="contained"
                color="primary"
                sx={{ height: 40, width: '100%' }}
                onClick={() => getShipmentList(1)}
              >
                <SearchIcon />
              </Button>
            </Grid>
            <Grid item xs={12} sm={4.5} md={1}>
              <Button
                variant="contained"
                color="primary"
                sx={{ height: 40, width: '100%' }}
                onClick={handleClearFilter}
              >
                <CloseIcon />
              </Button>
            </Grid>
          </Grid>
        </Box>

        {/* Buttons */}
        <Grid container spacing={2}>
          <Grid
            item
            display={'flex'}
            position={'relative'}
            flexDirection="row"
            xs={12}
            sm={4}
            md={2.3}
          >
            <Button
              variant="contained"
              fullWidth
              onClick={handleOpenRequirmentModal}
              style={{
                boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
                fontSize: 10,
                height: 20,
                borderRadius: 100,
                backgroundColor: isFilled ? theme.palette.primary.main : '#F0F0F9',
                color: isFilled ? 'white' : theme.palette.text.primary,
                border: isFilled ? 'none' : '1px solid rgb(229 229 229)'
              }}
            >
              Load Requirements
            </Button>
            {isFilled && (
              <IconButton
                style={{ height: 20, width: 20, position: 'absolute', right: 0 }}
                onClick={() => {
                  handleClearAll();
                  // setReSearch('1');
                }}
              >
                <CloseIcon style={{ fontSize: 11, color: '#ffffff' }} />
              </IconButton>
            )}
          </Grid>

          <Grid
            item
            display={'flex'}
            position={'relative'}
            flexDirection="row"
            xs={12}
            sm={4}
            md={2.3}
          >
            <Button
              variant="contained"
              fullWidth
              onClick={handleOpenSearchBack}
              style={{
                boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
                fontSize: 10,
                height: 20,
                borderRadius: 100,
                backgroundColor: isSearchFilled ? theme.palette.primary.main : '#F0F0F9',
                color: isSearchFilled ? 'white' : theme.palette.text.primary,
                border: isSearchFilled ? 'none' : '1px solid rgb(229 229 229)'
              }}
            >
              Search Back - 24 hrs
            </Button>
            {isSearchFilled && (
              <IconButton
                style={{ height: 20, width: 20, position: 'absolute', right: 0 }}
                onClick={() => {
                  handleClearAllSearchBack();
                }}
              >
                <CloseIcon style={{ fontSize: 11, color: '#ffffff' }} />
              </IconButton>
            )}
          </Grid>

          <Grid
            position={'relative'}
            item
            display={'flex'}
            flexDirection="row"
            xs={12}
            sm={4}
            md={2.3}
          >
            <Button
              variant="contained"
              fullWidth
              onClick={() => {
                setCompnayList([]);
                getCompanyList();
                handleOpenCompany();
              }}
              style={{
                fontSize: 10,
                boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
                height: 20,
                borderRadius: 100,
                backgroundColor: company ? theme.palette.primary.main : '#F0F0F9',
                color: company ? 'white' : theme.palette.text.primary,
                border: company ? 'none' : '1px solid rgb(229 229 229)'
              }}
            >
              Company
            </Button>
            {company && (
              <IconButton
                style={{ height: 20, width: 20, position: 'absolute', right: 0 }}
                onClick={() => {
                  clearSelectionCompany();
                }}
              >
                <CloseIcon style={{ fontSize: 11, color: '#ffffff' }} />
              </IconButton>
            )}
          </Grid>

          <Grid
            item
            position={'relative'}
            display={'flex'}
            flexDirection="row"
            xs={12}
            sm={4}
            md={2.3}
          >
            <Button
              variant="contained"
              fullWidth
              onClick={() => {
                setPrivateLoadButton(true);
                setReSearch('');
              }}
              style={{
                boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
                fontSize: 10,
                height: 20,
                borderRadius: 100,
                backgroundColor: privateLoadButton ? theme.palette.primary.main : '#F0F0F9',
                color: privateLoadButton ? 'white' : theme.palette.text.primary,
                border: privateLoadButton ? 'none' : '1px solid rgb(229 229 229)'
              }}
            >
              Private Loads
            </Button>
            {privateLoadButton && (
              <IconButton
                style={{ height: 20, width: 20, position: 'absolute', right: 0 }}
                onClick={() => {
                  setPrivateLoadButton(false);
                  setReSearch('4');
                }}
              >
                <CloseIcon style={{ fontSize: 11, color: '#ffffff' }} />
              </IconButton>
            )}
          </Grid>
        </Grid>

        {/* Content */}
        <TableContainer
          component={Paper}
          sx={{ boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', mt: 2, mb: 2 }}
        >
          <Table>
            <TableHead>
              <TableRow>
                {selectedTab === 0 && !loading && shipmentList.length !== 0 && (
                  <TableCell padding="checkbox">
                    <Checkbox
                      size="small"
                      checked={isAllSelected}
                      indeterminate={selected.length > 0 && selected.length < shipmentList.length}
                      onChange={handleSelectAll}
                    />
                  </TableCell>
                )}
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>AGE</TableCell>
                <TableCell
                  sx={{
                    fontSize: '12px',
                    color: '#010f58',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}
                >
                  REQ
                </TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>PICK UP</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>TRIP</TableCell>
                {/* <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>DH-O | DH-D</TableCell> */}
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>REFERENCE</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58', width: 300 }}>
                  EQUIPMENT
                </TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>RATE</TableCell>
                <TableCell sx={{ fontSize: '12px', color: '#010f58', width: '200px' }}>
                  MATCHES
                </TableCell>
                {userData?.role?.id == 6 && (
                  <TableCell sx={{ fontSize: '12px', color: '#010f58' }}>COMPANY</TableCell>
                )}
                <TableCell
                  sx={{
                    fontSize: '12px',
                    color: '#010f58',
                    position: 'sticky',
                    right: 68,
                    zIndex: 1,
                    backgroundColor: '#fff',
                    width: 110
                  }}
                >
                  STATUS
                </TableCell>
                <TableCell
                  align="right"
                  sx={{
                    fontSize: '12px',
                    color: '#010f58',
                    position: 'sticky',
                    right: 0,
                    zIndex: 1,
                    backgroundColor: '#fff',
                    width: 80
                  }}
                >
                  {selected.length > 0 && (
                    <>
                      <IconButton
                        onClick={handleMenuClick}
                        style={{ marginTop: -7, marginBottom: -7 }}
                      >
                        <Iconify icon="iwwa:option" style={{ fontSize: 20, color: '#010f58' }} />
                      </IconButton>
                      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                        <MenuItem sx={{ fontSize: 12 }} onClick={() => handleOptionSelect('1')}>
                          {optionsLoader && optionNumber == '1' ? (
                            <CircularProgress size={12} />
                          ) : (
                            'Post'
                          )}
                        </MenuItem>
                        <MenuItem sx={{ fontSize: 12 }} onClick={() => handleOptionSelect('2')}>
                          {optionsLoader && optionNumber == '2' ? (
                            <CircularProgress size={12} />
                          ) : (
                            'Unpost'
                          )}
                        </MenuItem>
                        <MenuItem sx={{ fontSize: 12 }} onClick={handleOpenAlert}>
                          Delete
                        </MenuItem>
                      </Menu>
                    </>
                  )}
                </TableCell>
              </TableRow>
            </TableHead>

            {!loading && (
              <TableBody>
                {shipmentList.map((truck, index) => (
                  <>
                    <TableRow
                      key={index}
                      onClick={() => {
                        handleRowClick(index);
                        setSelectLoad(truck);
                      }}
                      style={{ cursor: 'pointer' }}
                    >
                      {selectedTab === 0 && (
                        <TableCell align="left" padding="checkbox">
                          <Checkbox
                            size="small"
                            checked={selected.includes(truck)}
                            onChange={() => handleSelectRow(truck)}
                            disabled={truck.status.toLowerCase() === 'expired' ? true : false} // Disabled if the status is expired
                          />
                        </TableCell>
                      )}

                      <TableCell align="left">
                        <Typography style={{ fontSize: 12, width: 20 }}>{truck.age}</Typography>
                      </TableCell>

                      <TableCell sx={{ fontSize: '12px', width: 50 }}>
                        {truck?.bid_request == 1 ? (
                          <Iconify icon="streamline:check-solid" sx={{ color: '#010f58' }} />
                        ) : (
                          '-'
                        )}
                      </TableCell>

                      <TableCell align="left">
                        <Typography style={{ fontSize: 12, width: 75 }}>
                          {moment(truck.pickup_earliest).format('MM/DD/YYYY')} -{' '}
                          {moment(truck.pickup_lattest).format('MM/DD/YYYY')}
                        </Typography>
                      </TableCell>

                      <TableCell
                        align="left"
                        sx={{
                          fontSize: '12px',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'flex-start'
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            justifyContent: 'flex-start'
                          }}
                        >
                          <p
                            style={{
                              fontWeight: 'bold',
                              color: '#010f58',
                              marginRight: 5,
                              fontSize: 10
                            }}
                          >
                            {truck?.total_mil || '-'}
                          </p>
                          <div>
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                marginBottom: -5
                              }}
                            >
                              <div
                                style={{
                                  height: 6,
                                  width: 6,
                                  borderRadius: 100,
                                  backgroundColor: 'white',
                                  border: '2px solid #010f58',
                                  marginRight: 5
                                }}
                              ></div>
                              <p
                                style={{
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  maxWidth: '150px' // Adjust this width as needed
                                }}
                              >
                                {truck?.location_origin}
                              </p>
                            </div>
                            <div>
                              <Iconify
                                icon="mingcute:arrow-down-line"
                                style={{ fontSize: 14, marginLeft: -4.6, color: '#010f58' }}
                              />
                            </div>
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                marginTop: -10
                              }}
                            >
                              <div
                                style={{
                                  height: 6,
                                  width: 6,
                                  borderRadius: 100,
                                  backgroundColor: '#010f58',
                                  border: '2px solid #010f58',
                                  marginRight: 5
                                }}
                              ></div>
                              <p
                                style={{
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  maxWidth: '150px' // Adjust this width as needed
                                }}
                              >
                                {truck?.location_destination}
                              </p>
                            </div>
                          </div>
                        </div>
                      </TableCell>

                      <TableCell sx={{ fontSize: '12px' }}>{truck.reference_id}</TableCell>

                      <TableCell
                        sx={{
                          fontSize: '12px',
                          fontSize: '12px',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis'
                        }}
                      >
                        <div style={{ display: 'flex' }}>
                          <div
                            style={{ display: 'flex', flexDirection: 'column', marginRight: 10 }}
                          >
                            <p>{truck?.equipment_type || '-'} </p>
                            <p>{truck?.equipment_name || '-'} </p>
                          </div>
                          <div
                            style={{
                              flex: 1,
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'flex-end',
                              justifyContent: 'center'
                            }}
                          >
                            <p>
                              {truck.length_ft} {truck?.length_unit}
                            </p>
                            <p>
                              {truck.weight_lbs} {truck?.weight_unit}
                            </p>
                          </div>
                        </div>
                      </TableCell>

                      <TableCell align="left" sx={{ fontSize: '12px' }}>
                        {truck.rate ? (
                          <NumericFormat
                            value={truck.rate ? parseFloat(truck.rate).toFixed(2) : '0.00'}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'}
                          />
                        ) : (
                          '-'
                        )}
                      </TableCell>

                      <TableCell align="center" style={{ width: 150 }}>
                        <IconButton
                          component={RouterLink}
                          to="/dashboard/my_shipments/request_a_truck"
                          state={{ shipment_id: truck?.id }}
                          // onClick={() => {
                          //   navigate('/dashboard/my_shipments/request_a_truck');
                          // }}
                        >
                          <Iconify
                            icon={'streamline:shipment-download-solid'}
                            sx={{
                              color: '#010f58',
                              width: 20,
                              height: 20,
                              cursor: 'pointer'
                            }}
                          />
                        </IconButton>
                      </TableCell>

                      {userData?.role?.id == 6 && (
                        <TableCell sx={{ fontSize: '12px' }}>
                          <RouterLink
                            className="routerLink"
                            onClick={() => {
                              handleOpenDetailsModal();
                              setSelectLoad(truck);
                            }}
                            style={{
                              display: 'block' /* Ensure it behaves like a block element */,
                              whiteSpace:
                                'nowrap' /* Prevent the text from wrapping to the next line */,
                              overflow: 'hidden' /* Hide any overflowing text */,
                              overflow: 'ellipsis' /* Apply the ellipsis to truncated text */,
                              maxWidth: '100%'
                            }}
                          >
                            {truck.company.company
                              ? truck.company.company
                              : truck.company.first_name + ' ' + truck.company.last_name}
                          </RouterLink>
                        </TableCell>
                      )}
                      {/* <TableCell sx={{ fontSize: '12px', width: 125 }}>
                        {truck?.dhO && truck?.dhd ? `${truck?.dhO} | ${truck?.dhd}` : '-'}
                      </TableCell> */}

                      <TableCell
                        align="left"
                        style={{
                          position: 'sticky',
                          right: 68,
                          zIndex: 1,
                          background: '#fff'
                        }}
                      >
                        <Typography
                          className={
                            (truck.status.toLowerCase() == 'posted' && 'status-green') ||
                            (truck.status.toLowerCase() == 'completed' && 'status-green') ||
                            (truck.status.toLowerCase() == 'booked' && 'status-booked') ||
                            (truck.status.toLowerCase() == 'unposted' && 'status-blue') ||
                            (truck.status.toLowerCase() == 'pending' && 'status-blue') ||
                            (truck.status.toLowerCase() == 'paid' && 'status-blue') ||
                            (truck.status.toLowerCase() == 'partially fulfilled' &&
                              'status-blue') ||
                            (truck.status.toLowerCase() == 'expired' && 'status-red') ||
                            (truck.status.toLowerCase() == 'deleted' && 'status-red')
                          }
                        >
                          {truck.status || 'N/A'}
                        </Typography>
                      </TableCell>

                      {/* {truck.status.toLowerCase() !== 'expired' && ( */}
                      <TableCell
                        align="right"
                        style={{
                          position: 'sticky',
                          right: 0,
                          zIndex: 1,
                          background: '#fff'
                        }}
                      >
                        {/* Show row-specific 3-dot menu only if no bulk action is active */}
                        {selected.length === 0 && (
                          <IconButton onClick={(e) => handleMenuClick(e, truck)}>
                            <Iconify
                              icon="iwwa:option"
                              style={{ fontSize: 20, color: '#010f58' }}
                            />
                          </IconButton>
                        )}
                        <Menu
                          anchorEl={anchorEl}
                          open={Boolean(anchorEl) && selectedTruck === truck}
                          onClose={handleMenuClose}
                        >
                          {(truck.status.toLowerCase() == 'posted' ||
                            truck.status.toLowerCase() == 'unposted') && (
                            <MenuItem
                              sx={{ fontSize: 12 }}
                              onClick={() =>
                                handleOptionSelect(
                                  truck.status.toLowerCase() == 'posted' ? '2' : '1'
                                )
                              }
                            >
                              {optionsLoader ? (
                                <CircularProgress size={12} sx={{ alignContent: 'center' }} />
                              ) : truck.status.toLowerCase() == 'posted' ? (
                                'Unpost'
                              ) : (
                                'Post'
                              )}
                            </MenuItem>
                          )}

                          <MenuItem
                            sx={{ fontSize: 12 }}
                            component={RouterLink}
                            to="/dashboard/my_shipments/view_details"
                            state={{ viewOnly: true, detail_id: truck?.id }}
                          >
                            View Details
                          </MenuItem>

                          {truck?.bid_request && (
                            <MenuItem
                              sx={{ fontSize: 12 }}
                              component={RouterLink}
                              to="/dashboard/my_shipments/shipment_request"
                              state={{ shipment_id: truck?.id }}
                              // onClick={() => handleOpenRequest(truck.id)}
                            >
                              View Requests
                            </MenuItem>
                          )}

                          {truck?.allow_edit && (
                            <MenuItem sx={{ fontSize: 12 }} onClick={handleClickOpen}>
                              Extend Pickup Date
                            </MenuItem>
                          )}

                          {truck?.allow_edit && (
                            <MenuItem
                              sx={{ fontSize: 12 }}
                              component={RouterLink}
                              to="/dashboard/my_shipments/edit_shipment"
                              state={{ viewOnly: false, detail_id: truck?.id, data: truck }}
                            >
                              Edit
                            </MenuItem>
                          )}

                          {truck?.allow_delete && (
                            <MenuItem sx={{ fontSize: 12 }} onClick={handleOpenAlert}>
                              Delete
                            </MenuItem>
                          )}

                          {truck.status.toLowerCase() !== 'pending' && (
                            <MenuItem
                              sx={{ fontSize: 12 }}
                              component={RouterLink}
                              to="/dashboard/my_shipments/add_document"
                              state={{ shipmentDetail: truck, type: 'shipment' }}
                            >
                              Upload Document
                            </MenuItem>
                          )}

                          {truck?.allow_complete && truck.status.toLowerCase() == 'booked' && (
                            <MenuItem sx={{ fontSize: 12 }} onClick={handleOpenRating}>
                              Complete
                            </MenuItem>
                          )}

                          {truck.status.toLowerCase() == 'posted' && (
                            <MenuItem
                              sx={{ fontSize: 12 }}
                              component={RouterLink}
                              to="/dashboard/my_shipments/request_to_company"
                              state={{ shipment_id: truck?.id }}
                            >
                              Booker Profiles
                            </MenuItem>
                          )}
                          {truck.status.toLowerCase() == 'partially fulfilled' && (
                            <MenuItem sx={{ fontSize: 12 }} onClick={handleCheckout}>
                              {loadingcheckout ? (
                                <CircularProgress size={12} sx={{ alignContent: 'center' }} />
                              ) : (
                                'Pay Now'
                              )}
                            </MenuItem>
                          )}
                        </Menu>
                      </TableCell>
                      {/* )} */}
                    </TableRow>

                    <TableRow style={{ display: expandedRow !== index && 'none' }}>
                      <TableCell
                        style={{ backgroundColor: '#f0f0f0', paddingTop: 10, paddingBottom: 10 }}
                        colSpan={11}
                      >
                        <Collapse in={expandedRow === index} timeout="auto" unmountOnExit>
                          <Grid container spacing={2} mb={2} style={{ height: '30%' }}>
                            {/* Trip Section */}
                            <Grid item xs={12} sm={6} style={{ position: 'relative' }}>
                              {/* Header */}
                              <Box
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  backgroundColor: '#010f58',
                                  padding: '4px 10px',
                                  marginTop: 10,
                                  marginBottom: 10
                                }}
                              >
                                <p
                                  style={{
                                    fontSize: 10,
                                    letterSpacing: 0.8,
                                    color: 'white',
                                    fontWeight: 'bold'
                                  }}
                                >
                                  TRIP
                                </p>
                              </Box>

                              {/* Content Section */}
                              <Box
                                style={{
                                  marginTop: 2,
                                  paddingLeft: 10,
                                  paddingRight: 10,
                                  position: 'relative'
                                }}
                              >
                                {/* Row 1 */}
                                <Box
                                  style={{
                                    display: 'flex',
                                    alignItems: 'flex-start', // Align text and icons properly
                                    height: 60
                                  }}
                                >
                                  <Box
                                    style={{
                                      width: 13, // Fixed icon width
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      marginRight: 6
                                    }}
                                  >
                                    <Iconify
                                      icon="f7:dot-square-fill"
                                      style={{
                                        fontSize: 13, // Fixed icon size
                                        color: '#010f58'
                                      }}
                                    />
                                  </Box>
                                  <Typography
                                    style={{
                                      fontSize: 11,
                                      fontWeight: 'bold',
                                      lineHeight: '1.5', // Ensure consistent line spacing
                                      overflow: 'hidden', // Handle overflow
                                      textOverflow: 'ellipsis', // Add ellipsis if text is too long
                                      display: '-webkit-box', // Enable line clamping
                                      WebkitLineClamp: 3, // Limit to 3 lines
                                      WebkitBoxOrient: 'vertical', // Required for line clamping,
                                      color: '#010f58'
                                    }}
                                  >
                                    {selectLoad?.location_origin}
                                  </Typography>
                                </Box>

                                {/* Row 2 */}
                                <Box
                                  style={{
                                    display: 'flex',
                                    alignItems: 'flex-start', // Align text and icons properly
                                    height: 60
                                  }}
                                >
                                  <Box
                                    style={{
                                      width: 13, // Fixed icon width
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      marginRight: 6
                                    }}
                                  >
                                    <Iconify
                                      icon="f7:square-fill"
                                      style={{
                                        fontSize: 13, // Fixed icon size
                                        color: '#010f58'
                                      }}
                                    />
                                  </Box>
                                  <Typography
                                    style={{
                                      fontSize: 11,
                                      fontWeight: 'bold',
                                      lineHeight: '1.5', // Ensure consistent line spacing
                                      overflow: 'hidden', // Handle overflow
                                      textOverflow: 'ellipsis', // Add ellipsis if text is too long
                                      display: '-webkit-box', // Enable line clamping
                                      WebkitLineClamp: 3, // Limit to 3 lines
                                      WebkitBoxOrient: 'vertical', // Required for line clamping,
                                      color: '#010f58'
                                    }}
                                  >
                                    {selectLoad?.location_destination}
                                  </Typography>
                                </Box>
                              </Box>

                              {/* Vertical Icons */}
                              <Box
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  flexDirection: 'column',
                                  position: 'absolute',
                                  top: 70,
                                  left: 26.5
                                }}
                              >
                                {Array(4)
                                  .fill(null)
                                  .map((_, idx) => (
                                    <Iconify
                                      key={idx}
                                      icon="pepicons-pop:line-y"
                                      style={{
                                        fontSize: 7, // Fixed line size
                                        color: '#010f58',
                                        marginBottom: 3
                                      }}
                                    />
                                  ))}
                                <Iconify
                                  icon="ion:arrow-down-outline"
                                  style={{
                                    fontSize: 11, // Fixed arrow size
                                    color: '#010f58'
                                  }}
                                />
                              </Box>
                            </Grid>

                            {/* Details Section */}
                            <Grid item xs={12} sm={6}>
                              <Box
                                style={{
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  backgroundColor: '#010f58',
                                  padding: '4px 10px',
                                  marginTop: 10,
                                  marginBottom: 10
                                }}
                              >
                                <p
                                  style={{
                                    fontSize: 10,
                                    letterSpacing: 0.8,
                                    color: 'white',
                                    fontWeight: 'bold'
                                  }}
                                >
                                  DETAILS
                                </p>
                              </Box>

                              <Box
                                style={{
                                  paddingLeft: 10,
                                  paddingRight: 10
                                }}
                              >
                                <Box
                                  sx={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'flex-start',
                                    marginBottom: 0.5
                                  }}
                                >
                                  <Typography style={{ color: 'grey', fontSize: 12 }}>
                                    Commodity :
                                  </Typography>
                                  <Typography style={{ flex: 1, fontSize: 12, textAlign: 'right' }}>
                                    {selectLoad?.commodity || '-'}
                                  </Typography>
                                </Box>

                                <Box
                                  sx={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'flex-start',
                                    marginBottom: 0.5
                                  }}
                                >
                                  <Typography style={{ color: 'grey', fontSize: 12 }}>
                                    Reference ID :
                                  </Typography>
                                  <Typography style={{ flex: 1, fontSize: 12, textAlign: 'right' }}>
                                    {selectLoad?.reference_id || '-'}
                                  </Typography>
                                </Box>

                                <Box
                                  sx={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'flex-start',
                                    marginBottom: 0.5
                                  }}
                                >
                                  <Typography style={{ color: 'grey', fontSize: 12 }}>
                                    DHO | DHD :
                                  </Typography>
                                  <Typography style={{ flex: 1, fontSize: 12, textAlign: 'right' }}>
                                    {selectLoad?.dhO && selectLoad?.dhd
                                      ? `${selectLoad?.dhO} | ${selectLoad?.dhd}`
                                      : '-'}
                                  </Typography>
                                </Box>

                                <Box
                                  sx={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'flex-start',
                                    marginBottom: 0.5
                                  }}
                                >
                                  <Typography
                                    style={{
                                      width: '17%',
                                      color: 'grey',
                                      fontSize: 12
                                    }}
                                  >
                                    Comment :
                                  </Typography>
                                  <Typography
                                    style={{
                                      fontSize: 11,
                                      marginLeft: 20,
                                      flex: 1
                                    }}
                                  >
                                    {selectLoad?.comments || '-'}
                                  </Typography>
                                </Box>
                              </Box>
                            </Grid>
                          </Grid>

                          <Divider />

                          {/* MARKET RATE */}
                          <Box
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              marginTop: 20,
                              marginBottom: 10,
                              backgroundColor: '#010f58',
                              padding: '4px 0px 4px 10px'
                            }}
                          >
                            <p
                              style={{
                                fontSize: 10,
                                letterSpacing: 0.8,
                                fontWeight: 'bold',
                                color: 'white'
                              }}
                            >
                              MARKET RATE
                            </p>
                          </Box>

                          <Box
                            style={{
                              border: '2px solid #010f58',
                              marginBottom: 10,
                              paddingBottom: 10
                            }}
                          >
                            <Box
                              style={{
                                backgroundColor: '#010f58',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '2px 10px 2px 10px'
                              }}
                            >
                              <Typography
                                style={{
                                  fontSize: 10,
                                  letterSpacing: 0.8,
                                  fontWeight: 'bold',
                                  color: 'white'
                                }}
                              >
                                SPOT RATE
                              </Typography>
                              <Typography
                                style={{
                                  fontSize: 10,
                                  color: '#ffffff'
                                }}
                              >
                                {selectLoad?.city_origin !== 'undefined' &&
                                selectLoad?.city_destination !== 'undefined'
                                  ? `${selectLoad?.city_origin} - ${selectLoad?.city_destination}`
                                  : `${selectLoad?.country_origin} - ${selectLoad?.country_destination}`}
                                {/* {selectLoad?.city_origin} -{' '}
                                                  {selectLoad?.city_destination} */}
                              </Typography>
                            </Box>

                            <Typography
                              sx={{
                                fontSize: 10,
                                textAlign: 'end',
                                marginTop: 1,
                                marginRight: 1,
                                color: '#000000'
                              }}
                            >
                              {selectLoad?.total_mil || 0} km | 30d average
                            </Typography>

                            <Box
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '5px 10px 0px 10px'
                              }}
                            >
                              <Typography sx={{ fontSize: 12, color: '#999999', minWidth: '20%' }}>
                                Average rate :
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: 14,
                                  textAlign: 'right',
                                  flex: 1,
                                  color: '#000000'
                                }}
                              >
                                {selectLoad?.market_rate?.spot_rate?.average_rate
                                  ? `$${selectLoad?.market_rate?.spot_rate?.average_rate}/Km`
                                  : '0 /km'}
                              </Typography>
                            </Box>

                            <Box
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '0px 10px 0px 10px'
                              }}
                            >
                              <Typography sx={{ fontSize: 12, color: '#999999', minWidth: '20%' }}>
                                Average rate range :
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: 12,
                                  color: '#000000',
                                  textAlign: 'right',
                                  flex: 1
                                }}
                              >
                                {selectLoad?.market_rate?.spot_rate?.min_rate ||
                                selectLoad?.market_rate?.spot_rate?.max_rate
                                  ? `$${selectLoad?.market_rate?.spot_rate?.min_rate?.toFixed(
                                      2
                                    )}/Km - $${selectLoad?.market_rate?.spot_rate?.max_rate?.toFixed(
                                      2
                                    )}/Km`
                                  : '0 - 0'}
                              </Typography>
                            </Box>

                            <Box
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '0px 10px 0px 10px'
                              }}
                            >
                              <Typography sx={{ fontSize: 12, color: '#999999' }}>
                                Average amount range :
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: 12,
                                  color: '#000000',
                                  textAlign: 'right',
                                  flex: 1
                                }}
                              >
                                {selectLoad?.market_rate?.spot_rate?.min_rate ||
                                selectLoad?.market_rate?.spot_rate?.max_rate
                                  ? `$${selectLoad?.market_rate?.spot_rate?.min_rate?.toFixed(
                                      2
                                    )}/Km - $${selectLoad?.market_rate?.spot_rate?.max_rate?.toFixed(
                                      2
                                    )}/Km`
                                  : '0 - 0'}
                              </Typography>
                            </Box>

                            <Box
                              style={{
                                backgroundColor: '#010f58',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '2px 10px 2px 10px',
                                marginTop: 25
                              }}
                            >
                              <Typography
                                style={{
                                  fontSize: 10,
                                  letterSpacing: 0.8,
                                  fontWeight: 'bold',
                                  color: 'white'
                                }}
                              >
                                SHIPMENT RATE
                              </Typography>
                            </Box>

                            <Typography
                              sx={{
                                fontSize: 10,
                                textAlign: 'end',
                                marginTop: 1,
                                marginRight: 1,
                                color: '#000000',
                                marginBottom: 1
                              }}
                            >
                              {selectLoad?.total_mil || '0'} km
                            </Typography>

                            <Box
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '0px 10px 0px 10px'
                              }}
                            >
                              <Typography sx={{ fontSize: 12, color: '#999999' }}>
                                Rate :
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: 12,
                                  oolor: '#000000'
                                }}
                              >
                                <NumericFormat
                                  value={
                                    selectLoad?.rate_per_mil
                                      ? parseFloat(selectLoad?.rate_per_mil).toFixed(2)
                                      : '0'
                                  }
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  prefix={'$'}
                                  // style={{ marginRight: 5 }}
                                />
                              </Typography>
                            </Box>

                            <Divider style={{ marginTop: 5, marginBottom: 5 }} />
                            <Box
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '0px 10px 0px 10px'
                              }}
                            >
                              <Typography sx={{ fontSize: 12, color: '#999999' }}>
                                Total Amount :
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: 14,
                                  color: '#000000',
                                  textAlign: 'right',
                                  flex: 1,
                                  fontWeight: 'bold'
                                }}
                              >
                                ${selectLoad?.rate || '0'}
                              </Typography>
                            </Box>
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </>
                ))}
              </TableBody>
            )}

            {/* loader */}
            {loading && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={10} sx={{ py: 3 }}>
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              </TableBody>
            )}

            {/* empty list */}
            {shipmentList.length == 0 && !loading && (
              <TableBody>
                <TableRow>
                  <TableCell align="center" colSpan={10} sx={{ py: 3 }}>
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      alignItems="center"
                      height="55vh"
                    >
                      <img
                        src={Empty_Truck}
                        alt="No Shipment"
                        style={{ width: '130px', marginBottom: '20px', marginRight: 40 }}
                      />
                      <Typography variant="h6" gutterBottom>
                        You haven't added any shipment yet
                      </Typography>
                      <Typography variant="caption" color="textSecondary" gutterBottom>
                        Add and save shipment details that can be used to save time when creating
                        new posts.
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>

        {/* Pagination */}
        {!loading && pagesCount > 1 && shipmentList.length !== 0 && (
          <Box
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              marginTop: 20,
              alignItems: 'center',
              marginBottom: 20
            }}
          >
            <Pagination
              color="primary"
              shape="rounded"
              page={page}
              size="small"
              count={pagesCount}
              onChange={handlePageChange}
              renderItem={(item) => <PaginationItem {...item} />}
            />
          </Box>
        )}

        <Dialog open={openDetailsModal} onClose={handleCloseDetailsModal} fullWidth>
          <DialogTitle
            style={{
              height: 50,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              paddingLeft: 20,
              paddingRight: 10,
              marginBottom: 0
            }}
          >
            Company Information
            <IconButton onClick={handleCloseDetailsModal}>
              <Iconify icon="ic:round-clear" style={{ fontSize: 19 }} />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers style={{ paddingLeft: 20, paddingTop: 0 }}>
            {/* <Box sx={{ mt: 2 }}>
              <Box> */}
            <Grid
              container
              sx={{
                marginTop: 3,
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'flex-start'
              }}
            >
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginBottom: 0.5
                }}
              >
                <Typography sx={{ width: '11%', color: '#000', fontWeight: 'bold', fontSize: 16 }}>
                  Name :
                </Typography>
                <Typography sx={{ flex: 1, fontSize: 16 }}>
                  {selectLoad?.company?.company
                    ? selectLoad?.company?.company
                    : selectLoad?.company?.first_name + ' ' + selectLoad?.company?.last_name}
                </Typography>
              </Box>
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginBottom: 0.5
                }}
              >
                <Typography sx={{ width: '11%', color: '#000', fontWeight: 'bold', fontSize: 16 }}>
                  Email :
                </Typography>
                <Typography sx={{ flex: 1, fontSize: 16 }}>{selectLoad?.company?.email}</Typography>
              </Box>
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginBottom: 0.5
                }}
              >
                <Typography sx={{ width: '11%', color: '#000', fontWeight: 'bold', fontSize: 16 }}>
                  Score :
                </Typography>
                <Typography sx={{ flex: 1, fontSize: 16 }}>{selectLoad?.company?.score}</Typography>
              </Box>
            </Grid>
            {/* </Box>
            </Box> */}
          </DialogContent>
        </Dialog>

        <Dialog open={open} onClose={handleClose} maxWidth="xs">
          <DialogTitle>Extend Pickup Latest Date</DialogTitle>
          <DialogContent>
            <Typography sx={{ fontSize: 12 }}>
              Your posts will be automatically refreshed every morning, up to the last pickup date.
            </Typography>
            <div style={{ display: 'flex', alignItems: 'center', marginTop: '16px' }}>
              <LoadingButton
                size="small"
                onClick={handleDecrement}
                style={{
                  justifyContent: 'center',
                  width: 30, // Less than 30
                  height: 30, // Ensuring it's a square button
                  minWidth: 30, // Ensuring minimum width is set to 30
                  padding: 0, // Removing padding to fit the icon properly
                  lineHeight: 1, // Ensuring the icon is centered
                  alignSelf: 'center',
                  marginLeft: 0.5,
                  backgroundColor: 'rgba(255, 72, 66, 0.16)',
                  color: '#FF4842',
                  border: '1.5px solid rgba(255, 72, 66, 0.5)'
                }}
                to="#"
              >
                <Remove sx={{ fontSize: 15 }} />
              </LoadingButton>
              <TextField
                variant="outlined"
                value={days}
                style={{ width: '30%', textAlign: 'center', margin: '0px 10px' }}
                inputProps={{ min: 1, style: { textAlign: 'center' } }}
                readOnly
                disabled={true}
                className="custom-textfield"
              />
              <LoadingButton
                size="small"
                onClick={handleIncrement}
                style={{
                  justifyContent: 'center',
                  width: 30, // Less than 30
                  height: 30, // Ensuring it's a square button
                  minWidth: 30, // Ensuring minimum width is set to 30
                  padding: 0, // Removing padding to fit the icon properly
                  lineHeight: 1, // Ensuring the icon is centered
                  alignSelf: 'center',
                  marginLeft: 0.5,
                  backgroundColor: 'rgba(84, 214, 44, 0.16)',
                  color: '#54D62C',
                  border: '1.5px solid rgba(84, 214, 44, 0.5)'
                }}
                to="#"
              >
                <Add sx={{ fontSize: 15 }} />
              </LoadingButton>
            </div>
          </DialogContent>
          <DialogActions sx={{ marginTop: -2 }}>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <LoadingButton loading={extendLoading} onClick={ExtendDaysFuntion} color="primary">
              Extend
            </LoadingButton>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openAlertModal}
          onClose={handleCloseAlert}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{'Confirmation'}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to proceed?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseAlert} color="primary">
              No
            </Button>
            <LoadingButton
              variant="contained"
              loading={optionsLoader}
              onClick={() => {
                handleOptionSelect('4');
              }}
              color="primary"
              autoFocus
            >
              Yes
            </LoadingButton>
          </DialogActions>
        </Dialog>

        {/* Map Dialog */}
        <Dialog open={mapOpen} onClose={() => setMapOpen(false)} maxWidth="md" fullWidth>
          <DialogContent>
            <LocationPickerMap
              open={mapOpen}
              onClose={() => setMapOpen(false)}
              locationType={locationType}
              selectedLocationFromForm={locationType === 'origin' ? origin : destination}
              onSelectLocation={handleSelectLocation}
            />
          </DialogContent>
        </Dialog>

        {/* RATING */}
        <Dialog
          open={openRatingModal}
          onClose={handleCloseRating}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          // sx={{ width: "70%" }}
          fullWidth
        >
          <DialogTitle id="alert-dialog-title">{'Rating & Review'}</DialogTitle>
          <DialogContent>
            <Rating name="simple-controlled" value={rating} onChange={handleRatingChange} />
            <TextField
              fullWidth
              margin="normal"
              label="Your Review"
              multiline
              rows={4}
              variant="outlined"
              value={review}
              onChange={handleReviewChange}
              style={{ fontSize: 12 }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseRating} color="primary">
              Cancel
            </Button>
            <LoadingButton
              variant="contained"
              loading={optionsLoader}
              onClick={handleAddRatingReview}
              color="primary"
              autoFocus
            >
              Submit
            </LoadingButton>
          </DialogActions>
        </Dialog>

        {/* Search Back Dialog */}
        <Dialog open={openSearchBack} onClose={handleCloseSearchBack} maxWidth="xs" fullWidth>
          <DialogTitle style={{ height: 40 }}>
            Search Book
            <IconButton onClick={handleCloseSearchBack} sx={{ alignSelf: 'end', float: 'right' }}>
              <Iconify icon="ic:round-clear" style={{ fontSize: 19 }} />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            {/* Age in Hours Input */}
            <TextField
              type="number"
              label="Age in hours"
              value={ageInHours}
              onChange={(e) => setAgeInHours(e.target.value)}
              fullWidth
              margin="normal"
              className="custom-textfield"
              onKeyDown={(e) => {
                if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                  e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                }
              }}
            />
            {/* Text Below Input */}
            <Typography
              style={{ fontSize: 12, marginLeft: 13, marginTop: -5 }}
              color="textSecondary"
              margin="normal"
            >
              Searches back in hours from the current time
            </Typography>
          </DialogContent>

          <DialogActions>
            <Button onClick={handleClearAllSearchBack} color="primary">
              Clear All
            </Button>
            <Button onClick={handleDoneSearchBack} variant="contained" color="primary">
              Done
            </Button>
          </DialogActions>
        </Dialog>

        {/* REQUIRMENT MODAL */}
        <Dialog
          open={openRequirmentModal}
          onClose={handleCloseRequirmentModal}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle style={{ height: 50 }}>
            Load Requirements
            <IconButton
              onClick={handleCloseRequirmentModal}
              sx={{ alignSelf: 'end', float: 'right' }}
            >
              <Iconify icon="ic:round-clear" style={{ fontSize: 19 }} />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            {/* Load Type Radio Buttons */}
            <FormControl fullWidth>
              <RadioGroup
                value={loadType}
                onChange={(e) => setLoadType(e.target.value)}
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-start',
                  alignItems: 'center',
                  marginBottom: -1
                }}
              >
                <FormControlLabel
                  sx={{ width: '30%' }}
                  value="All"
                  control={<Radio size="small" />}
                  label={<Typography style={{ fontSize: '12px' }}>All</Typography>}
                />
                <FormControlLabel
                  sx={{ width: '30%' }}
                  value="Full"
                  control={<Radio size="small" />}
                  label={<Typography style={{ fontSize: '12px' }}>Full</Typography>}
                />
                <FormControlLabel
                  sx={{ width: '30%' }}
                  value="Partial"
                  control={<Radio size="small" />}
                  label={<Typography style={{ fontSize: '12px' }}>Partial</Typography>}
                />
              </RadioGroup>
            </FormControl>

            {/* Length Input */}
            <TextField
              name="length"
              label={`Length (${length_unit}.) `}
              value={length}
              onChange={handleChange}
              fullWidth
              margin="normal"
              type="number"
              className="custom-textfield"
              sx={{ marginBottom: 0 }}
              onKeyDown={(e) => {
                if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                  e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                }
              }}
              InputProps={{
                endAdornment: (
                  <select
                    value={length_unit} // Default to "ft" if not set
                    onChange={(e) => setLength_unit(e.target.value)}
                    style={{
                      border: 'none',
                      outline: 'none',
                      background: 'transparent',
                      cursor: 'pointer',
                      fontSize: 12
                    }}
                  >
                    <option value="ft">ft</option>
                    <option value="m">m</option>
                  </select>
                )
              }}
            />

            {/* Weight Input */}
            <TextField
              name="weight"
              label={`Weight (${weight_unit}.)`}
              value={weight}
              onChange={handleChange}
              fullWidth
              type="number"
              margin="normal"
              className="custom-textfield"
              onKeyDown={(e) => {
                if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                  e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                }
              }}
              InputProps={{
                endAdornment: (
                  <select
                    value={weight_unit} // Default to "ft" if not set
                    onChange={(e) => setWeight_unit(e.target.value)}
                    style={{
                      border: 'none',
                      outline: 'none',
                      background: 'transparent',
                      cursor: 'pointer',
                      fontSize: 12
                    }}
                  >
                    <option value="kg">kg</option>
                    <option value="lbs">lbs</option>
                  </select>
                )
              }}
            />
          </DialogContent>

          <DialogActions style={{ height: 50, marginTop: -10 }}>
            {/* Buttons in Dialog */}
            <Button onClick={handleClearAll} color="primary">
              Clear All
            </Button>
            <Button onClick={handleDone} variant="contained" color="primary">
              Done
            </Button>
          </DialogActions>
        </Dialog>

        {/* COMAPNY LIST MODAL */}
        <Dialog open={openCompany} onClose={handleCloseCompany} fullWidth maxWidth="sm">
          <DialogTitle>
            Company
            <Button
              onClick={clearSelectionCompany}
              variant="contained"
              startIcon={<Iconify icon="ic:round-clear" style={{ fontSize: 19 }} />}
              sx={{ alignSelf: 'end', fontSize: 11, float: 'right' }}
            >
              Clear
            </Button>
          </DialogTitle>
          <DialogContent>
            {compnayList.length == 0 && openCompany ? (
              <Box
                py={2}
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  flex: 1
                }}
              >
                <CircularProgress />
              </Box>
            ) : (
              <>
                {compnayList.map((val) => (
                  <Grid item xs={12} key={val?.id} sx={{ marginBottom: 1 }}>
                    <Button
                      fullWidth
                      variant={company == val?.id ? 'contained' : 'outlined'}
                      onClick={() => handleCompanyClick(val?.id)}
                      sx={{ display: 'flex', alignItems: 'flex-start' }}
                    >
                      <Typography
                        sx={{
                          flex: 1,
                          fontSize: 13,
                          textAlign: 'left'
                        }}
                      >
                        {val?.company ? val?.company : val?.first_name + ' ' + val?.last_name}
                      </Typography>
                    </Button>
                  </Grid>
                ))}
              </>
            )}
          </DialogContent>
        </Dialog>

        <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Container>
    </Page>
  );
}
